import React from 'react';
import { TextField } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import Autocomplete from '@mui/material/Autocomplete';
import { __ } from '../../../tools';
import style from './style.module.scss';

export const SelectAutocomplete = ({ options, onChange = () => null, value, name, ...props }) => {
    const handleChange = (event, newValue) => {
        onChange(newValue);
    };

    return (
        <Autocomplete
            className={style.autocomplete}
            classes={{ paper: style.paper }}
            options={options.map((option) => option.value)}
            getOptionLabel={(value) => {
                const found = options && options.find((option) => option.value === value);
                return found ? found.label : value;
            }}
            onChange={handleChange}
            value={value}
            renderInput={(params) => (
                <TextField name={name} placeholder={__('Sélectionner')} className={style.item} {...params} />
            )}
            popupIcon={<ExpandMore />}
            {...props}
        />
    );
};

export default SelectAutocomplete;
